import { Component, OnInit } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { UserManagementService } from "../../core/services/user-management.service";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { ProfileFormService } from "../../core/services/profile-form.service";
import { SharedService } from "../../core/services/shared.service";
import { UserRole } from "../../shared/enums/userRoles.enum";
import { TabsModule } from "primeng/tabs";
import { BcReportComponent } from "./components/bc-report/bc-report.component";
import { ManagerReportComponent } from "./components/manager-report/manager-report.component";
import { BacReportComponent } from "./components/bac-report/bac-report.component";
import { CardModule } from "primeng/card";
import { ModalStackerComponent } from "../../shared/components/modal-stacker/modal-stacker.component";
import { OrdersComponent } from "../orders/orders.component";
import { YTDGPComponent } from "../bcledger/components/ytdgp/ytdgp.component";
import { BacklogDetailsComponent } from "../bcledger/components/backlog-details/backlog-details.component";
import { BcLedgerStacker } from "../../core/models/bcLedgers/bcLedgerStacker";

@Component({
  selector: "jni-dashboard-poc",
  templateUrl: "./dashboard-poc.component.html",
  styleUrls: ["./dashboard-poc.component.scss"],
  providers: [DatePipe],
  imports: [
    TabsModule,
    CommonModule,
    BcReportComponent,
    ManagerReportComponent,
    BacReportComponent,
    CardModule,
    ModalStackerComponent,
    OrdersComponent,
    YTDGPComponent,
    BacklogDetailsComponent,
  ],
})
export class DashboardPocComponent implements OnInit {
  isAdmin = false;
  isBac = false;
  isBc = false;
  isManager = false;
  isSuperManager = false;
  userRole = 0;
  orderListingDisplayModal = false;
  displayModalBacklog = false;
  bcLedgerStacker: BcLedgerStacker = {} as BcLedgerStacker;
  constructor(
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private _sharedService: SharedService
  ) {}

  ngOnInit() {
    this.getUserProfile();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.isAdmin = true;
        }

        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: res => {
        if (res?.data) {
          this.isManager = res?.data?.managerAccess;
          this.isSuperManager = res?.data?.superManagerAccess;
          if (this.userRole != UserRole.Admin) {
            if (
              res?.data.loginEmail &&
              res?.data?.title?.toLowerCase()?.includes("branding consultant")
            ) {
              this.isBc = true;
            } else {
              this.isBac = true;
            }
          }
        }
      },
    });
  }
  openOrderListingModal(flag: boolean) {
    this.orderListingDisplayModal = flag;
  }

  closeBcLedgerModal() {
    this.displayModalBacklog = false;
  }

  populate(bcLedgerStackerEvent: BcLedgerStacker) {
    this.bcLedgerStacker.Path = bcLedgerStackerEvent.Path;
    this.bcLedgerStacker.BrandingConsultantID =
      bcLedgerStackerEvent.BrandingConsultantID ?? "";
    this.bcLedgerStacker.FromDate = bcLedgerStackerEvent.FromDate;
    this.bcLedgerStacker.ToDate = bcLedgerStackerEvent.ToDate;
    this.bcLedgerStacker.CategoryID = bcLedgerStackerEvent.CategoryID;
    this.displayModalBacklog = true;
  }
}
